import { useAtom } from 'jotai';
import { useCallback } from 'react';
import {
  NotificationData,
  notificationsAtom,
} from '../atoms/notificationAtoms';

export const useNotification = () => {
  const [notifications, setNotifications] = useAtom(notificationsAtom);

  const showNotification = useCallback(
    (notification: Omit<NotificationData, 'id'>) => {
      const notificationWithId: NotificationData = {
        ...notification,
        id: `notification-${Date.now()}-${Math.random()}`,
      };
      setNotifications((previousNotifications) => [
        ...previousNotifications,
        notificationWithId,
      ]);
    },
    [setNotifications]
  );

  const showSuccessNotification = useCallback(
    (message: string, heading = 'Success') => {
      showNotification({
        autoCloseTimeoutMS: 5000,
        heading,
        message,
        type: 'success',
      });
    },
    [showNotification]
  );

  const showErrorNotification = useCallback(
    (message: string, heading = 'Error') => {
      showNotification({
        autoCloseTimeoutMS: 5000,
        heading,
        message,
        type: 'error',
      });
    },
    [showNotification]
  );

  const showWarningNotification = useCallback(
    (message: string, heading = 'Warning') => {
      showNotification({
        autoCloseTimeoutMS: 5000,
        heading,
        message,
        type: 'warning',
      });
    },
    [showNotification]
  );

  const showInfoNotification = useCallback(
    (message: string, heading = 'Info') => {
      showNotification({
        autoCloseTimeoutMS: 5000,
        heading,
        message,
        type: 'info',
      });
    },
    [showNotification]
  );

  const closeNotification = useCallback(
    (notificationId: string) => {
      setNotifications((previousNotifications) =>
        previousNotifications.filter(
          (notification) => notification.id !== notificationId
        )
      );
    },
    [setNotifications]
  );

  return {
    closeNotification,
    notifications,
    showErrorNotification,
    showInfoNotification,
    showNotification,
    showSuccessNotification,
    showWarningNotification,
  };
};
